import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardIngunzioneService from "./dashboardIngunzioniService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
// import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
toast.configure();

class Ingiunzioni extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataTableIngunzioni: [],
      dataTableIngunzionimodificate: [],
      dataTableIngunzioniCSVDownload: [],
      headerDataTableIngunzioni: [],
      searchNumIngunzioni: "",
      searchDataEmissione: "",
      searchNome: "",
      searchCognome: "",
      export:[],
      searchCF: "",
      loading: true,
      filtro: {
        dataInizio: "",
        dataFine: "",
      },
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.csvLinkEl = React.createRef();
  }

  componentDidMount() {
    this.DashboardIngunzioneService = new DashboardIngunzioneService();
    var search = this.props.location.search;
    var stato = "aperte";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.state.filtro.dataFine = moment(new Date()).format("YYYY-MM-DD")
    this.state.filtro.dataInizio = moment(this.state.filtro.dataFine, "YYYY-MM-DD").subtract(29, "d").format("YYYY-MM-DD")
    this.getDataTable(stato);


    
  }


  getExportCSV(stato) {
    this.DashboardIngunzioneService.getExportCSV(
      stato,
      this.state.filtro.dataInizio,
        this.state.filtro.dataFine,
      this.onSuccesExportCSV.bind(this)
    );
  }
  // (dati.importo / 100).toFixed(2),
  onSuccesExportCSV(result) {
    //primi campi del CSV
    if(result.data.length <= 0){
      toast.error("Non ci sono record da esportare")
    }else{
    this.setState({export:[]});
    result.data.map((val) => {
      this.state.export = [
        ...this.state.export,
        {
          numIngiunzione:val.numIngiunzione,
          importoIngiunzione: parseFloat(val.importoIngiunzione / 100) +"€",
          dataCreazione :geDataFormat(val.dataCreazione),
          nomeStato:val.statoIngiunzione.nomeStato,
          idSanzione: val.sanzione.idSanzione,
          numeroSanzione: val.sanzione.numeroSanzione,
          protocolloSanzione: val.sanzione.protocolloSanzione,
          matricolaControllore: val.sanzione.matricolaControllore,
          importo: parseFloat(val.sanzione.importo / 100).toFixed(2),
          dataDiEmissione:geDataFormat(val.sanzione.dataDiEmissione),
          annotazioneControllore: val.sanzione.annotazioneControllore,
          isverbaleFattoABordo: val.sanzione.isverbaleFattoABordo,
          nomeViolazione: val.sanzione.anagraficaTipologiaSanzione.nomeViolazione,
          nomeStatoSaznione: val.sanzione.anagraficaStati.nomeStato,
          idAnagraficaTrasgressore:
            val.sanzione.anagraficaTrasgressore.idAnagraficaTrasgressore,
          nomeTrasgressore: val.sanzione.anagraficaTrasgressore.nome,
          cognomeTrasgressore: val.sanzione.anagraficaTrasgressore.cognome,
          codiceFiscaleTrasgressore: val.sanzione.anagraficaTrasgressore.codiceFiscale,
          dataDiNascitaTrasgressore: geDataFormat(val.sanzione.anagraficaTrasgressore.dataRilascioDocumento),
          luogoDiNascitaTrasgressore:
            val.sanzione.anagraficaTrasgressore.luogoDiNascita,
          isMinorenneTrasgressore: val.sanzione.anagraficaTrasgressore.isMinorenne,
          numeroDocumentoTrasgressore:
            val.sanzione.anagraficaTrasgressore.numeroDocumento,
          enteRilascioDocumentoTrasgressore:
            val.sanzione.anagraficaTrasgressore.enteRilascioDocumento,
          inidirizzoDiResidenzaTrasgressore:
            val.sanzione.anagraficaTrasgressore.inidirizzoDiResidenza,
          inidirizzoNumeroDiResidenzaTrasgressore:
            val.sanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza,
          capDiResidenzaTrasgressore:
            val.sanzione.anagraficaTrasgressore.capDiResidenza,
          provinciaDiResidenzaTrasgressore:
            val.sanzione.anagraficaTrasgressore.provinciaDiResidenza,
          idAnagraficaPotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.idAnagraficaTrasgressore,
          nomePotestaTrasgressore: val.sanzione.anagraficaPotestaTrasgressore.nome,
          cognomePotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.cognome,
          codiceFiscalePotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.codiceFiscale,
          dataDiNascitaPotestaTrasgressore:
          geDataFormat(val.sanzione.anagraficaPotestaTrasgressore.dataDiNascita),
          luogoDiNascitaPotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.luogoDiNascita,
          isMinorennePotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.isMinorenne,
          numeroDocumentoPotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.numeroDocumento,
          dataRilascioDocumentoPotestaTrasgressore:
          geDataFormat(val.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento),
          enteRilascioDocumentoPotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.enteRilascioDocumento,
          inidirizzoDiResidenzaPotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza,
          inidirizzoNumeroDiResidenzaPotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza,
          capDiResidenzaPotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.capDiResidenza,
          provinciaDiResidenzaPotestaTrasgressore:
            val.sanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza,
        }
      ];
    })
    this.setState(
      {
        dataTableIngunzioniCSVDownload: this.state.export,
      },
      () => {
        setTimeout(() => {
          this.csvLinkEl.current.link.click();
        });
      }
    );
  }

    
  }


  onClickCSVDownLoad() {
    var search = this.props.location.search;
    var stato = "aperte";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.getExportCSV(stato);
    this.csvLink.current.link.click();
    // console.log(this.csvLink.current.link)
  }

  

  getDataTable(stato) {
    this.DashboardIngunzioneService.getDataTableSanzioni(
      stato,
      this.state.filtro.dataInizio,
      this.state.filtro.dataFine,
      this.onSuccessLoadDataTableSanzione.bind(this)
    );
  }

  onSuccessLoadDataCharter(result) {
    this.setState((this.data = result));
  }
  onSuccessLoadDataTableSanzione(resultHeader, resultBody) {
    var sanzioni = resultBody;
    var numSanzioniInscadenza = 0;
    for (let i = 0; i < sanzioni.length; i++) {
      var sanzione = sanzioni[i];
      var allaScadenza = "-";
      if ("Caricato" === sanzioni[i].statoSanzione) {
        var diff = calculateTimeDifferenceTwoDates(
          new Date(),
          moment(sanzione.dataEmissione, "DD/MM/YYYY").toDate()
        );
        allaScadenza = 60 - parseInt(diff, 10);
        var val = "-";
        if (allaScadenza < 0) {
          val = "Scaduto";
          numSanzioniInscadenza += 1;
        } else {
          val = "Scade tra " + allaScadenza + " giorni";
          if (allaScadenza < 5) numSanzioniInscadenza += 1;
        }
        sanzione.giorniAllaScadenza = val;
      } else {
        sanzione.giorniAllaScadenza = " - ";
      }
    }
    // var mexError =
    //   "Attenzione " + numSanzioniInscadenza + " sanzioni in scadenza!";
    // if (numSanzioniInscadenza > 5)
    //   toast.warn(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else if (numSanzioniInscadenza > 10)
    //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else toast.info(numSanzioniInscadenza + " sanzioni in scadenza ");
    this.setState((this.headerDataTableIngunzioni = resultHeader));
    this.setState({ dataTableIngunzioniCSV: resultBody });
    //qui si riempe con il BE
    // this.setState({ dataTableIngunzioni: resultBody });
    //qui con il mookUp
    this.setState({ dataTableIngunzioni: this.state.dataTableIngunzioniCSV });
    this.setState({ loading: false });
  }

  onRowClick(row) {
    row.statoSanzione = "";

    var search = this.props.location.search;
    var stato = "aperte";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.id = {};
    if (stato === "aperte") {
      row.statoSanzione = "IngiunzioneAperta";
    }
    if (stato === "pagate") {
      row.statoSanzione = "IngiunzionePagata";
    }
    if (stato === "chiuse") {
      row.statoSanzione = "IngiunzioneChiusa";
    }

    sessionStorage.removeItem("rowSanzione");
    sessionStorage.setItem("rowSanzione", JSON.stringify(row));
    this.props.history.push("/detailSanzione");
  }

  // onIngiunzioneClick() {
  //   // sessionStorage.removeItem("rowSanzioneIngiunzione");
  //   // sessionStorage.setItem("rowSanzioneIngiunzione", JSON.stringify(row));

  //   console.log(this.props.history);

  //   if (this.props.history.location.pathname === "/ingiunzioni") {
  //     // sessionStorage.removeItem("rowIngiunzione");
  //     // sessionStorage.setItem("rowIngiunzione", JSON.stringify(row))
  //     this.props.history.push("/Ingiunzione");
  //   } else {
  //     this.props.history.push("/detailSanzione");
  //   }
  // }

  onRowClickPush(idIngiunzione) {
    // sessionStorage.removeItem("rowIngiunzione");
    // window.sessionStorage.setItem("rowIngiunzione", JSON.stringify(row));

    var search = this.props.location.search;
    var stato = "aperte";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.statoIngiunzione = {};
    if (stato === "aperte") {
      this.statoIngiunzione = "IngiunzioneAperta";
    }
    if(stato === "postalizzate"){
      this.statoIngiunzione  = "Postalizzata"
    }
    if (stato === "pagate") {
      this.statoIngiunzione = "IngiunzionePagata";
    }
    if (stato === "chiuse") {
      this.statoIngiunzione = "IngiunzioneChiusa";
    }

    if (this.props.history.location.pathname === "/ingiunzioni") {
      sessionStorage.removeItem("rowIngiunzione");
      sessionStorage.setItem(
        "rowIngiunzione",
        JSON.stringify({ id: idIngiunzione , statoSanzione:this.statoIngiunzione})
      );
      this.props.history.push("/Ingiunzione");
    } else {
      this.props.history.push("/detailSanzione");
    }
  }

  dataObj() {
    this.state.dataTableIngunzionimodificate = [];
    this.state.dataTableIngunzioni.map((dati) => {
      this.state.dataTableIngunzionimodificate = [
        ...this.state.dataTableIngunzionimodificate,
        {
          numIngiunzione: dati.numIngiunzione,
          numSanzione: (
            <>
              <button
                className="btn btn-link"
                onClick={() => {
                  var search = this.props.location.search;
                  var stato = "aperte";
                  if (search != null && search.includes("?")) {
                    stato = search.substring(1, search.lenght);
                  }
                  this.id = {};
                  if (stato === "aperte") {
                    this.id = {
                      id: dati.idSanzione,
                      statoSanzione: "IngiunzioneAperta",
                    };
                  }
                  if (stato === "pagate") {
                    this.id = {
                      id: dati.idSanzione,
                      statoSanzione: "IngiunzioneChiusa",
                    };
                  }
                  if(stato === "postalizzate"){
                    this.id = {
                      id:dati.idSanzione,
                      statoSanzione: "IngiunzionePostalizzata"
                    };
                  }
                  if (stato === "chiuse") {
                    this.id = {
                      id: dati.idSanzione,
                      statoSanzione: "IngiunzionePagata",
                    };
                  }
                  sessionStorage.removeItem("rowSanzione");
                  sessionStorage.setItem(
                    "rowSanzione",
                    JSON.stringify(this.id)
                  );
                  this.props.history.push("/detailSanzione");
                }}
              >
                {dati.numSanzione}
              </button>
            </>
          ),
          dataCreazione: geDataFormat(dati.dataCreazione),
          importo:
            parseFloat(dati.importo / 100).toFixed(2)
              .toString()
              .replace(".", ",") + "€",
        },
      ];
    });
    var data = {
      columns: this.headerDataTableIngunzioni,
      rows: this.state.dataTableIngunzionimodificate,
    };

    // for (const item of this.state.dataTableIngunzionimodificate) {
    //   item.clickEvent = () => this.onRowClickPush(item.id);
    // }

    this.state.dataTableIngunzionimodificate.map((item) => {
      item.clickEvent = () => this.onRowClickPush(item.numIngiunzione);
    });
    return data;
  }

  onChangeDataInizio(event) {
    this.state.filtro.dataInizio = event.target.value;
    this.setState({ filtro: this.state.filtro });
  }

  onChangeDataFine(event) {
    this.state.filtro.dataFine = event.target.value;
    this.setState({ filtro: this.state.filtro });

    // var search = this.props.location.search;
    // var stato = "aperte";
    // if (search != null && search.includes("?")) {
    //   stato = search.substring(1, search.lenght);
    // }
    // this.getDataTable(
    //   stato,
    //   this.state.filtro.dataInizio,
    //   this.state.filtro.dataFine
    // );
  }

  renderTableData() {
    if (
      this.state.dataTableIngunzioni &&
      this.state.dataTableIngunzioni.length > 0
    ) {
      return (
        <CDBContainer>
          <CDBCard border>
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="col">Data Inizio: </div>
                  <div className="col">
                    <input
                      value={this.state.filtro.dataInizio}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataInizio.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="col">Data Fine: </div>
                  <div className="col">
                    <input
                      value={this.state.filtro.dataFine}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataFine.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  {/* <div className="col">Filtri: </div> */}
                  <br></br>
                  <div className="col">
                    <button
                      className="btn btn-warning"
                      style={{ width: "100%" }}
                      onClick={() => {
                        var search = this.props.location.search;
                        var stato = "aperte";
                        if (search != null && search.includes("?")) {
                          stato = search.substring(1, search.lenght);
                        }
                        this.getDataTable(stato);
                      }}
                    >
                      Applica Filtri
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CDBCardBody>
              <CDBDataTable
                sortable={false}
                responsiveSm={true}
                responsiveMd={true}
                responsiveLg={true}
                pagesAmount={3}
                entriesLabel={""}
                infoLabel={["Mostra da", "a", "di", "ingiunzioni totali"]}
                paginationLabel={["<-", "->"]}
                striped
                bordered
                hover
                checkbox
                data={this.dataObj()}
                materialSearch
              />
            </CDBCardBody>
          </CDBCard>
        </CDBContainer>
      );
    } else {
      return (
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="col">Data Inizio: </div>
              <div className="col">
                <input
                  value={this.state.filtro.dataInizio}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataInizio.bind(this)}
                />
              </div>
            </div>
            <div className="col">
              <div className="col">Data Fine: </div>
              <div className="col">
                <input
                  value={this.state.filtro.dataFine}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataFine.bind(this)}
                />
              </div>
            </div>
            <div className="col">
              {/* <div className="col">Filtri: </div> */}
              <br></br>
              <div className="col">
                <button
                  className="btn btn-warning"
                  style={{ width: "100%" }}
                  onClick={() => {
                    var search = this.props.location.search;
                    var stato = "aperte";
                    if (search != null && search.includes("?")) {
                      stato = search.substring(1, search.lenght);
                    }
                    this.getDataTable(stato);
                  }}
                >
                  Applica Filtri
                </button>
              </div>
            </div>
          </div>
          <br></br>
          <h4>Nessuna ingiunzione trovata nel periodo specificato</h4>
        </div>
      );
    }
  }

  render() {

    var search = this.props.location.search;
    var stato = "aperte";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }


    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Ingiunzioni<br></br>
              <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              >
                Ingiunzioni &#8594; {stato === "aperte"
                  ? "Ingiunzioni Aperte"
                  : stato === "pagate"
                  ? "Pagate"
                  : stato === "chiuse"
                  ? "Chiuse"
                  : stato === "postalizzate"
                  ? "Postalizzate"
                  : ""}
              </small>
            </h1>
            <button
              type="button"
              class="btn btn-warning"
              onClick={this.onClickCSVDownLoad.bind(this)}
            >
              {" "}
              <i className="fas fa-download fa-sm text-white"></i> &nbsp;Esporta
              Ingiunzioni
            </button>
            {/* <CSVLink data={this.state.dataTableIngunzioniCSV} separator={";"} filename="Ingiunzioni.csv"> */}
              {/* <button type="button" class="btn btn-warning">
                {" "}
                <i className="fas fa-mail-bulk fa-sm text-white"></i>{" "}
                &nbsp;Esporta Ingunzioni
              </button> */}
            {/* </CSVLink> */}
            <CSVLink
              data={this.state.dataTableIngunzioniCSVDownload} separator={";"} ref={this.csvLinkEl} filename={"Ingiunzioni_"+stato +".csv"}
            />
          </div>
          <br />
          <br />
          <div className="col">{this.renderTableData()}</div>
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(Ingiunzioni);
